export default "__VITE_ASSET__Csc86ch$__"